import type { SupplyProgram } from '@shared/types';
import { PROGRAM_LABELS } from '@shared/types';
import { SUPPLY_PROGRAMS } from '@shared/validation';

/** What each program covers, so nobody has to guess which one their item is under. */
const PROGRAM_BLURB: Record<SupplyProgram, string> = {
  kitchen: 'Food, coffee, and kitchen consumables.',
  cleaning: 'Janitorial and cleaning supplies.',
};

/**
 * First step of a request: which catalog am I ordering out of? Styled to match
 * StationSelect, which is the step immediately after this one.
 */
export default function ProgramSelect({ onSelect }: { onSelect: (p: SupplyProgram) => void }) {
  return (
    <div className="mx-auto max-w-2xl px-4 py-8">
      <h1 className="text-xl font-bold text-white mb-1">What are you ordering?</h1>
      <p className="text-sm text-zinc-400 mb-6">
        Kitchen and cleaning supplies are ordered separately. You can switch later.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {SUPPLY_PROGRAMS.map((p) => (
          <button
            key={p}
            type="button"
            onClick={() => onSelect(p)}
            className="glass rounded-xl p-4 text-left text-white hover:border-dcvfd-accent transition-colors"
          >
            <div className="font-semibold">{PROGRAM_LABELS[p]}</div>
            <div className="text-xs text-zinc-400">{PROGRAM_BLURB[p]}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
